import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import ReactCardFlip from "react-card-flip";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import Card from "@mui/material/Card";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

const ColorButton = styled(Button)(() => ({
  color: "#fff",
  width: 225,
  height: 50,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#D7A036",
  borderColor: "#D7A036",
  "&:hover": {
    color: "#fff",
    backgroundColor: "#049593",
    borderColor: "#049593",
  },
}));

const ColorButton2 = styled(Button)(() => ({
  color: "#fff",
  width: 235,
  height: 55,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#D7A036",
  borderColor: "#D7A036",
  "&:hover": {
    color: "#fff",
    backgroundColor: "#004165",
    borderColor: "#004165",
  },
}));

const ColorButton3 = styled(Button)(() => ({
  color: "#fff",
  width: 200,
  height: 45,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#D7A036",
  borderColor: "#D7A036",
  "&:hover": {
    color: "#fff",
    backgroundColor: "#004165",
    borderColor: "#004165",
  },
}));

function Climate() {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setIsFlipped(!isFlipped);
  };

  return (
    <Grid
      item
      alignItems={"center"}
      xs={12}
      md={4}
      marginBottom={{ xs: "1%", sm: "0%" }}
      marginLeft={{ xs: "0%", sm: "0%" }}
      position={"relative"}
    >
      <ReactCardFlip isFlipped={isFlipped} flipDirection="vertical">
        <Box
          marginBottom={{ xs: "7%", sm: "0%" }}
          backgroundColor={"#19376D"}
          component={Card}
          sx={{
            textDecoration: "none",
            textAlign: "center",
            "&:hover": {
              backgroundColor: "#D7A036",
            },
          }}
          position={"relative"}
          height={{ xs: "30vh", sm: "360px" }}
        >
          <Typography
            variant={"h5"}
            fontWeight={800}
            color={"#fff"}
            sx={{
              "&:hover": {
                color: "#ddd",
              },
            }}
            marginTop={"5%"}
            position={"absolute"}
            top={{ xs: "20%", sm: "15%" }}
            padding={{ xs: "2%", sm: "12%" }}
            width={"100%"}
            textAlign={"center"}
          >
            Award for Climate Change Activism
            <Typography
              component={"span"}
              color="#fff"
              fontWeight={700}
              variant={"body2"}
            >
              {" "}
              - [Nominations]
            </Typography>
          </Typography>
          <Box
            padding={"2% 2% 1% 4%"}
            width={"100%"}
            position={"absolute"}
            top={{ xs: "25%", sm: "80%" }}
            display={{ xs: "none", sm: "block" }}
          >
            <ColorButton2
              component={"a"}
              variant="outlined"
              size="medium"
              target={"_blank"}
              href={
                "https://docs.google.com/forms/d/e/1FAIpQLSdhM3JKG5ILUe05khZbo4ALFWaqk9rZFW_RhBei-jTohEjyag/viewform?vc=0&c=0&w=1&flr=0"
              }
              endIcon={
                <ArrowRightAltIcon
                  sx={{
                    color: "#fff",
                    height: "32px",
                    width: "32px",
                  }}
                />
              }
            >
              Nominate Now!
            </ColorButton2>
          </Box>
          <Box
            padding={"2% 2% 1% 4%"}
            width={"100%"}
            position={"absolute"}
            top={{ xs: "77%", sm: "75%" }}
            display={{ xs: "block", sm: "none" }}
          >
            <ColorButton3
              component={"a"}
              variant="outlined"
              size="medium"
              target={"_blank"}
              href={
                "https://docs.google.com/forms/d/e/1FAIpQLSdhM3JKG5ILUe05khZbo4ALFWaqk9rZFW_RhBei-jTohEjyag/viewform?vc=0&c=0&w=1&flr=0"
              }
            >
              Nominate Now!
            </ColorButton3>
          </Box>
          <AutorenewIcon
            onClick={handleClick}
            sx={{
              bottom: "4%",
              right: "5%",
              cursor: "pointer",
              textAlign: "right",
              position: "absolute",
              color: "#fff",
            }}
          />
        </Box>
        <Box>
          <Typography
            variant={"body1"}
            color={"#fff"}
            padding={{ xs: "5%", sm: "7%" }}
          >
            This award recognizes efforts made to climate change awareness.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#fff"}
            padding={{ xs: "0% 2% 0% 5%", sm: "5% 2% 1% 5%" }}
            fontWeight={800}
          >
            2023 Winner
          </Typography>
          <Typography
            variant={"body1"}
            color={"#fff"}
            padding={{ xs: "0% 2% 0% 5%", sm: "0% 2% 0% 5%" }}
            fontWeight={500}
          >
            Lauritta Boniface
          </Typography>
          <Typography
            variant={"caption"}
            color={"#fff"}
            padding={{ xs: "0% 2% 0% 5%", sm: "0% 2% 1% 5%" }}
            fontWeight={700}
          >
            Ecocykle
          </Typography>
          <Box padding={"2% 2% 1% 4%"} width={"100%"}>
            <ColorButton
              component={"a"}
              variant="outlined"
              size="medium"
              href={"/2023-shortlisted-nominees"}
            >
              View 2023 Nominees
            </ColorButton>
          </Box>
          <AutorenewIcon
            onClick={handleClick}
            sx={{
              bottom: "0%",
              right: "4%",
              cursor: "pointer",
              textAlign: "right",
              position: "absolute",
            }}
          />
        </Box>
      </ReactCardFlip>
    </Grid>
  );
}

export default Climate;
